<template>
  <div class="modal-card has-text-centered" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("settings.attention") }}
      </p>
    </header>

    <section class="modal-card-body">
      <p>
        {{ $t("settings.catalogReplaceNote1") }} ({{ destinyStoreName }})
        {{ $t("settings.catalogReplaceNote2") }} {{ sourceStoreName }}
        {{ $t("settings.catalogReplaceNote3") }}
        <br />
        {{ $t("settings.toContinueInsertPassword") }}
      </p>
      <br />

      <b-input
        v-model="password"
        type="password"
        :placeholder="$t('settings.yourPassword')"
        password-reveal
        style="max-width: 400px; margin: auto;"
      ></b-input>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button class="button is-danger" type="button" @click="deleteCatalog">
        {{ $t("settings.replaceCatalogButton") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  props: [
    "sourceStoreId",
    "sourceStoreName",
    "destinyStoreId",
    "destinyStoreName"
  ],

  mixins: [common],

  data() {
    return {
      isLoading: false,
      password: ""
    };
  },

  methods: {
    deleteCatalog() {
      this.isLoading = true;
      this.$store
        .dispatch("copyCatalog", {
          sourceStoreId: this.sourceStoreId,
          destinyStoreId: this.destinyStoreId,
          password: this.password
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("settings.catalogReplaced"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
